// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import * as R from "ramda";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { Tag, ListItem } from "./styles";
import Icon from "src/components/Icon";
import * as colors from "src/styles/constants/colors";

type Props = {
  column: string,
  processLabels: Object,
  fields: Object,
  clearSort: Function,
};

const SortableItem = ({ column, processLabels, fields, clearSort }: Props) => {
  const {
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const id = R.head((column || "").split(":") || "");
  return (
    <ListItem
      ref={setNodeRef}
      style={{ ...style, visibility: isDragging ? "hidden" : "visible" }}
    >
      <Tag>
        <span>
          {isNaN(id) ? processLabels[id] : fields[id]}
          {i18n.t(k._)}
        </span>
        {R.includes("asc", column) ? (
          <strong>{i18n.t(k.ASCENDING)}</strong>
        ) : (
          <strong>{i18n.t(k.DESCENDING)}</strong>
        )}
        <Icon
          icon="close"
          color={colors.active}
          onClick={() => clearSort(column)}
        />
      </Tag>
      <div
        ref={setActivatorNodeRef}
        {...listeners}
        style={{ cursor: "pointer" }}
      >
        <Icon icon="draggable" />
      </div>
    </ListItem>
  );
};

export default SortableItem;
